'use strict';

module.exports = (app) => app.factory('processDataService', /* @ngInject */ function (httpService, apiConfig) {

    /**
     * @param orderNumber {string}
     * @returns promise {Promise<any>}
     */
    function getProcessInstancesByOrderNumber(orderNumber) {
        const url = apiConfig.getBase('order', orderNumber, 'process');

        return httpService.get(url.toString(), {isArray: true});
    }

    /**
     * @param processInstance {ProcessInstance}
     * @param orderNumber {string}
     * @returns Promise<{value: string}>
     */
    function getProcessBpmnXml(processInstance, orderNumber) {
		const uri = apiConfig.getBase('order', orderNumber, 'process', 'bpmn');
		uri.query.processDefinitionId = processInstance.definitionId;
		return httpService.get(
            uri.toString()
        );
    }

	/**
	 * @returns Promise<{value: string}>
	 */
	function getBpmnXmlForActiveOrderProcess() {
		return httpService.get(
			apiConfig.getBase('workflow', 'order', 'bpmn').toString()
		);
	}

	/**
	 * @returns Promise<{value: string}>
	 */
	function getBpmnXmlForActivePurchaseRequisitionProcess() {
		return httpService.get(
			apiConfig.getBase('workflow', 'purchase-requisition', 'bpmn').toString()
		);
	}

    return {
        getProcessInstancesByOrderNumber,
        getProcessBpmnXml,
		getBpmnXmlForActiveOrderProcess,
		getBpmnXmlForActivePurchaseRequisitionProcess
    }
});
